"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var USER_EVENTS;

(function (USER_EVENTS) {
  USER_EVENTS["PAGE_VIEW"] = "PAGE_VIEW";
  USER_EVENTS["VIRTUAL_PAGE_VIEW"] = "VIRTUAL_PAGE_VIEW";
  USER_EVENTS["COMPONENT_ADD"] = "COMPONENT_ADD";
  USER_EVENTS["COMPONENT_ERROR"] = "COMPONENT_ERROR";
  USER_EVENTS["DATA_FETCH_ERROR"] = "DATA_FETCH_ERROR";
  USER_EVENTS["ELEMENT_INTERACTION"] = "ELEMENT_INTERACTION";
  USER_EVENTS["GDPR_ACTION"] = "GDPR_ACTION";
  USER_EVENTS["NAVIGATION"] = "NAVIGATION";
  USER_EVENTS["USER_METADATA"] = "USER_METADATA";
})(USER_EVENTS || (USER_EVENTS = {}));

var _default = USER_EVENTS;
exports["default"] = _default;
module.exports = exports["default"];